import { useState } from "react";
import Select from "react-select";

function OfferFormacionPermanente() {
  const [modalidad, setModalidad] = useState(null);
  const [organiza, setOrganiza] = useState(null);
  const [campo, setCampo] = useState(null);

  const optionsmodalidad = [
    { value: "todos", label: "Todas las modalidades" },
    { value: "en línea", label: "En línea" },
    { value: "presencial", label: "Presencial" },
    { value: "semipresencial", label: "Semipresencial" },
  ];

  const optionsorganizan = [
    { value: "todos", label: "Todas los programas" },
    { value: "Cátedra Unesco UTPL", label: "Cátedra Unesco UTPL" },
    { value: "CIMA UTPL", label: "CIMA UTPL" },
    { value: "EDES UTPL", label: "EDES UTPL" },
    { value: "ESCOP UTPL", label: "ESCOP UTPL" },
  ];

  const optionscampo = [
    { value: "todos", label: "Todos los programas" },

    {
      value: "Ciencias Sociales",
      label: "Ciencias Sociales",
    },
    {
      value: "Desarrollo Sostenible",
      label: "Desarrollo Sostenible",
    },
    {
      value: "Salud y Bienestar",
      label: "Salud y Bienestar",
    },
    {
      value: "Industria y Construcción",
      label: "Industria y Construcción",
    },
    {
      value: "Informática y Tecnología",
      label: "Informática y Tecnología",
    },
    {
      value: "Negocios y Administración",
      label: "Negocios y Administración",
    },
  ];

  function IsTag(data) {
    if (data && data.trim && data.trim() !== "") {
      return <p className="tag-2">{data}</p>;
    }
    return null; // Renderiza nada si data está vacío
  }

  function IsOrganiza(data) {
    if (data && data.trim && data.trim() !== "") {
      return (
        <p>
          <b>Organiza:</b> {data}
        </p>
      );
    }
    return null; // Renderiza nada si data está vacío
  }

  function IsDuracion(data) {
    if (data && data.trim && data.trim() !== "") {
      return (
        <p>
          <b>Duración:</b> {data}
        </p>
      );
    }
    return null; // Renderiza nada si data está vacío
  }

  const programas = [
    {
      titulo: "Agenda 2030 y Objetivos de Desarrollo Sostenible",
      organiza: "Cátedra Unesco UTPL",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Ciencias Sociales",
      url: "https://formacionpermanente.utpl.edu.ec/agenda2030",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Bioética Social",
      organiza: "",
      modalidad: "en línea",
      duracion: "",
      campo: "Salud y Bienestar",
      url: "https://formacionpermanente.utpl.edu.ec/bioeticasocial",
      inicio: "31 de julio de 2025",
    },
    {
      titulo:
        "Diplomado en Construcción de Paz: Estrategias Educativas y Gestión Contra la Violencia",
      organiza: "",
      modalidad: "en línea",
      duracion: "200 horas",
      campo: "Ciencias Sociales",
      url: "https://formacionpermanente.utpl.edu.ec/diplomadodepaz",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Diplomado en Gobierno Abierto",
      organiza: "",
      modalidad: "en línea",
      duracion: "",
      campo: "Ciencias Sociales",
      url: "https://formacionpermanente.utpl.edu.ec/gobiernoabierto",
      inicio: "4 de agosto de 2025",
    },
       {
      titulo: "Diplomado en Procedimientos Administrativos y Acciones Contencioso-Administrativas",
      organiza: "",
      modalidad: "en línea",
      duracion: "144 horas",
      campo: "Ciencias Sociales",
      url: "https://formacionpermanente.utpl.edu.ec/procedimientosadministrativos",
      inicio: "28 de julio de 2025",
    },
    {
      titulo: "Doctrina Social de la Iglesia",
      organiza: "",
      modalidad: "en línea",
      duracion: "",
      campo: "Ciencias Sociales",
      url: "https://formacionpermanente.utpl.edu.ec/doctrinaiglesia",
      inicio: "31 de julio de 2025",
    },
  /*   {
      titulo:
        "Ecoetiquetado: Sellos y Certificaciones Ambientales de Productos y Servicios",
      organiza: "",
      modalidad: "en línea",
      duracion: "",
      campo: "Salud y Bienestar",
      url: "https://formacionpermanente.utpl.edu.ec/ecoetiquetado",
      inicio: "30 de junio de 2025",
    }, */
    {
      titulo: "Educación para el Desarrollo Sostenible",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/educaciondesarrollosostenible",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Fundamentos de Ganadería Sostenible",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/fundamentosganaderiasostenible",
      inicio: "31 de julio de 2025",
    },
    {
      titulo:
        "Inteligencia artificial para mejorar tus habilidades profesionales",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/inteligenciaartificial/habilidadesprofesionales",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Introducción al Liderazgo Católico",
      organiza: "",
      modalidad: "en línea",
      duracion: "",
      campo: "Ciencias Sociales",
      url: "",
      inicio: "31 de junio de 2025",
    },
    {
      titulo: "Licencia Tipo G",
      organiza: "ESCOP UTPL",
      modalidad: "Semipresencial",
      duracion: "",
      campo: "Industria y Construcción",
      url: "https://escoputpl.ec/",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Medición de los Objetivos de Desarrollo Sostenible",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/medicionobjetivos",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Políticas Públicas para el Desarrollo Sostenible",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/politicaspublicas",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Prevención de Consumo de Sustancias",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Salud y Bienestar",
      url: "https://formacionpermanente.utpl.edu.ec/prevencionconsumosustancias",
      inicio: "31 de julio de 2025",
    },
    {
      titulo: "Resolución de Conflictos Sociales: Herramientas de Gestión",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/resolucionconflictos",
      inicio: "31 de julio de 2025",
    },
    {
      titulo:
        "Seguridad en manipulación almacenamiento y transporte de sustancias químicas controladas",
      organiza: "CIMA UTPL",
      modalidad: "en línea",
      duracion: "",
      campo: "Informática y Tecnología",
      url: "https://formacionpermanente.utpl.edu.ec/sustanciasquimicascontroladas",
      inicio: "30 de junio de 2025",
    },
  /*   {
      titulo:
        "Seguridad en Manipulación, Almacenamiento y Transporte de Explosivos",
      organiza: "CIMA UTPL",
      modalidad: "en línea",
      duracion: "16 horas",
      campo: "Industria y Construcción",
      url: "https://formacionpermanente.utpl.edu.ec/lmacenamiento-transporte-explosivos",
      inicio: "31 de julio de 2025",
    }, */
    {
      titulo: "Semana Internacional EAFIT (Medellín - Colombia)",
      organiza: "EDES UTPL",
      modalidad: "presencial",
      duracion: "35 horas",
      campo: "Negocios y Administración",
      url: "https://formacionpermanente.utpl.edu.ec/semanainternacional-eafit",
      inicio: "24 al 30 de agosto de 2025",
    },
    {
      titulo: "Semana Internacional EDEM (Valencia - España)",
      organiza: "EDES UTPL",
      modalidad: "presencial",
      duracion: "35 horas",
      campo: "Negocios y Administración",
      url: "https://formacionpermanente.utpl.edu.ec/semanainternacional-edem",
      inicio: "1 al 5 de septiembre de 2025",
    },
    {
      titulo: "Territorialización de los ODS",
      organiza: "",
      modalidad: "en línea",
      duracion: "40 horas",
      campo: "Desarrollo Sostenible",
      url: "https://formacionpermanente.utpl.edu.ec/territorializacionods",
      inicio: "31 de julio de 2025",
    },
    

    // Agrega los demás programas aquí con la misma estructura...
  ];

  const handleChangeModalidad = (selected) => {
    setModalidad(selected);
  };
  const handleChangeOrganizan = (selected) => {
    setOrganiza(selected);
  };
  const handleChangeCampo = (selected) => {
    setCampo(selected);
  };

  const programasFiltrados = programas.filter((p) => {
    const coincideModalidad =
      !modalidad ||
      modalidad.value === "todos" ||
      p.modalidad.toLowerCase() === modalidad.value.toLowerCase();

    const coincideOrganiza =
      !organiza ||
      organiza.value === "todos" ||
      p.organiza.toLowerCase() === organiza.value.toLowerCase();

    const coincideCampo =
      !campo ||
      campo.value === "todos" ||
      p.campo.toLowerCase() === campo.value.toLowerCase();

    return coincideModalidad && coincideOrganiza && coincideCampo;
  });

  return (
    <div>
      <div className="bloque1 flex-center new-offer">
        <div>
          <p>
            <b>Modalidad</b>
          </p>
          <Select
            options={optionsmodalidad}
            defaultValue={optionsmodalidad[0]}
            onChange={handleChangeModalidad}
          />
        </div>
        <div>
          <p>
            <b>Organizan</b>
          </p>
          <Select
            options={optionsorganizan}
            defaultValue={optionsorganizan[0]}
            onChange={handleChangeOrganizan}
          />
        </div>

        <div>
          <p>
            <b>Campo</b>
          </p>
          <Select
            options={optionscampo}
            defaultValue={optionscampo[0]}
            onChange={handleChangeCampo}
          />
        </div>
      </div>

      <div className="bloque2 margin">
        <div className="wrapper-academicoffer">
          {programasFiltrados.map((programa, index) => (
            <div key={index}>
              {programa.imagen && (
                <img src={programa.imagen} alt={programa.titulo} />
              )}
              <div className="layout8">
                <h3>{programa.titulo}</h3>
                {IsOrganiza(programa.organiza)}

                <p>
                  <b>Modalidad: </b>
                  {programa.modalidad}
                </p>
                {IsDuracion(programa.duracion)}

                <p>
                  <b>Campo del conocimiento: </b>
                  {programa.campo}
                </p>

                {programa.periodo && (
                  <p>
                    <b>Periodo: </b>
                    {programa.periodo}
                  </p>
                )}
                {programa.inicio && (
                  <p>
                    <b>Inicio de clases: </b>
                    {programa.inicio}
                  </p>
                )}
                <div className="wrapper-link">
                  <a
                    className="link-offer"
                    href={programa.url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons">arrow_forward_ios</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
          {programasFiltrados.length === 0 && (
            <p>No hay programas disponibles.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default OfferFormacionPermanente;
